export default __webpack_public_path__ + "static/media/manage-ams.4cf83588.svg";